import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  FormHelperText,
  InputLabel,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import FormInput from "./FormInput";
import daysInMonth from "../../utils/daysInMonth";
import { currentYear, earliestPlausibleYear } from "../register/RegisterForm";

const FormDOBInput: React.FC = () => {
  const { t } = useTranslation();
  const [{}, { error }, { setValue: setDOBValue }] = useField("dob");
  const [{ value: day }, {}, { setValue: setDayValue }] = useField("day");
  const [{ value: month }] = useField("month");
  const [{ value: year }, {}, { setValue: setYearValue }] = useField("year");

  useEffect(() => {
    if (!year) {
      return;
    }

    if (year > currentYear) {
      setYearValue(currentYear);
    }

    if (!month || !day) {
      return;
    }

    const userDOB = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
    );

    if (year && month && daysInMonth(year, month) < day) {
      setDayValue(daysInMonth(year, month));
    }

    if (userDOB instanceof Date && !isNaN(userDOB.getTime())) {
      setDOBValue(userDOB);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day, month, year]);

  return (
    <>
      <InputLabel data-testid="dobTitle" style={{ marginBottom: 12 }}>
        {t("register.dateOfBirth")}
      </InputLabel>
      <Grid container direction="row" wrap="nowrap" spacing={1}>
        <Grid item xs={3}>
          <FormInput
            type="number"
            name="day"
            inputProps={{
              min: 1,
              max: daysInMonth(year, month),
              step: 1,
            }}
            label={t("register.day")}
          />
        </Grid>
        <Grid item xs={3}>
          <FormInput
            type="number"
            name="month"
            inputProps={{
              min: 1,
              max: 12,
              step: 1,
            }}
            label={t("register.month")}
          />
        </Grid>
        <Grid item xs={6}>
          <FormInput
            type="number"
            name="year"
            inputProps={{
              min: earliestPlausibleYear,
              max: { currentYear },
              step: 1,
            }}
            label={t("register.year")}
          />
        </Grid>
      </Grid>

      {error && (
        <Grid container>
          <Grid item>
            <FormHelperText error={true}>
              <Typography
                component="span"
                variant="body1"
                data-testid="errorDob"
              >
                {error}
              </Typography>
            </FormHelperText>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FormDOBInput;
